import { Subscription } from 'rxjs';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DatePickerComponent, DatePickerModule } from '@syncfusion/ej2-angular-calendars';
import { AutomaticParkingFormGroup } from './automatic-parking-form.type';
import { ClientDTO } from 'src/app/base/models/models.swagger.generated';
import { ClientService } from 'src/app/base/services/client/client.service';
import { TranslateModule } from '@ngx-translate/core';
import { ClientAutocompleteComponent } from '../../../../../base/shared/client-autocomplete/client-autocomplete.component';

@Component({
    selector: 'app-automatic-parking-form',
    templateUrl: './automatic-parking-form.component.html',
    styleUrls: ['./automatic-parking-form.component.scss'],
    imports: [ReactiveFormsModule, ClientAutocompleteComponent, DatePickerModule, TranslateModule]
})
export class AutomaticParkingFormComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(ClientAutocompleteComponent)
  public clientAutocomplete: ClientAutocompleteComponent;

  @ViewChild('startTime')
  public startTimePicker: DatePickerComponent;

  @ViewChild('endTime')
  public endTimePicker: DatePickerComponent;

  @Input()
  public form: AutomaticParkingFormGroup;

  @Output()
  public searchDTOChanged = new EventEmitter<any>();

  public get selectedClient(): ClientDTO {
    return this.clientService.selectedClient;
  }

  public set selectedClient(value: ClientDTO) {
    if (this.clientService.selectedClient != value) {
      this.clientService.selectedClient = value;
    }
    // Defer the event emission to avoid ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.onClientSelected(value);
    });
  }

  private subscriptions = new Subscription();
  constructor(
    protected clientService: ClientService
  ) {
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.form.valueChanges.subscribe(() => {
        if (this.endTimePicker) {
          if (this.form.controls.startDate.value) {
            this.endTimePicker.min = this.form.controls.startDate.value;
          } else {
            this.endTimePicker.min = null;
          }
        }

        if (this.startTimePicker) {
          if (this.form.controls.endDate.value) {
            this.startTimePicker.max = this.form.controls.endDate.value;
          } else {
            this.startTimePicker.max = null;
          }
        }

        this.searchDTOChanged.emit();
      }));
  }

  ngAfterViewInit(): void {
    if (!this.selectedClient) {
      this.focusClientAutocomplete();
    }
  }

  public ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }

  public onClientSelected(client: ClientDTO): void {
    this.searchDTOChanged.emit();
  }

  private focusClientAutocomplete(): void {
    if (this.clientAutocomplete) {
      this.clientAutocomplete.focus();
    }
  }
}
